import React from 'react'
import "./AddmitionCimg.css"
function AddmitionCimg() {
  return (
   <>
   
    <div className="adpage-hero" style={{ backgroundImage: "url('/images/sihsbuilding.jpg')" }}>
      <div className="adoverlay">
        <h1>Admission Criteria</h1>
      </div>
    </div>
    </>
  )
}

export default AddmitionCimg